import React from 'react';
import { Link } from 'react-router-dom';
import { SUPPORT_EMAIL } from '../utils/legal';
import '../styles/legal.css';

const LegalFooter = () => (
  <footer className="legal-footer">
    <Link to="/privacy">Privacy</Link>
    <span aria-hidden="true">·</span>
    <Link to="/terms">Terms</Link>
    <span aria-hidden="true">·</span>
    <a href={`mailto:${SUPPORT_EMAIL}`}>Contacts</a>
  </footer>
);

export default LegalFooter;
